
export default {
  props: {
    propsData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    siderList: {
      type: Array,
      default: () => {
        return []
      },
    },
    searchBarFixed: {
      type: Boolean,
      default: false,
    },
    offsetBottom: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detailName: '',
      footerHeight: 0,
      // 供应链特殊项：code → 跳转路径（带 hash 定位）
      specialLinks: {
        supplyChainProduct: '/supplychain/supplychain#business-products-internationalFreightForwarder',
        supplyChainNetwork: '/supplychain/supplychain#logistics-network-airNetwork',
      },
    }
  },
  computed: {
    getBottomOffset() {
      return this.offsetBottom + this.footerHeight + 'px'
    },
  },
  watch: {
    offsetBottom(val) {}
  },
  created() {
    this.setDefaultActive()
  },
  mounted() {
    const offseHeight = document.querySelector('.footer-wrapper')?.offsetHeight
    this.footerHeight = offseHeight
  },
  methods: {
    handleSpecialClick(code) {
      const path = this.specialLinks[code]
      if (path) {
        const { site, lang } = this.$route.params
        window.location.href = `/${site}/${lang}${path}`
      }
    },
    setDefaultActive() {
      // 选中
      const fullPath = this.$route.fullPath
      const path = fullPath.split('?')[0]
      const pathList = path.split('/')
      const detailName = pathList[pathList.length - 1]
      this.detailName = detailName
    },
    getTitle(item) {
      if (item.cname) return item.cname
      if (this.$route.params.site !== 'jp') return ''
      const defaultTitles = {
        1: 'product.intlProductService',
        2: 'product.packageService',
        4: 'product.supplyChainService',
      }
      const key = defaultTitles[item.productType]
      return key ? this.$t(key) : ''
    },
  },
}
